/**
 * Regex ozel karakterlerini escape eder.
 * MongoDB $regex sorgularinda kullanici girdisini guvenli hale getirir.
 */
export function escapeRegex(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const TR_MAP: Record<string, string> = {
  'i': '[iİ]', 'İ': '[iİ]', 'ı': '[ıI]', 'I': '[ıI]',
  'ş': '[şŞ]', 'Ş': '[şŞ]', 'ç': '[çÇ]', 'Ç': '[çÇ]',
  'ö': '[öÖ]', 'Ö': '[öÖ]', 'ü': '[üÜ]', 'Ü': '[üÜ]',
  'ğ': '[ğĞ]', 'Ğ': '[ğĞ]',
};

export function turkceDuyarsizRegex(deger: string): string {
  if (!deger?.trim()) return '';
  return Array.from(escapeRegex(deger.trim())).map(c => TR_MAP[c] || c).join('');
}

export function turkceKucuk(s: string): string {
  return s?.replace(/İ/g, 'i').replace(/I/g, 'ı').replace(/Ş/g, 'ş').replace(/Ç/g, 'ç').replace(/Ö/g, 'ö').replace(/Ü/g, 'ü').replace(/Ğ/g, 'ğ').toLowerCase() || '';
}
